import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";

export type FormValues = {
  selectedEmails: string[];
};

export type RequestType = "profile_refresh" | "document_refresh";

export type RequestLabels = {
  modalTitle: string;
  bannerTitle: string;
  bannerDescriptionSingle: (sentencePart: string) => string;
  bannerDescriptionMultiple: string;
  instructionText: string;
  successMessage: string;
  resendSuccessMessage: string;
  errorMessage: string;
  resendErrorMessage: string;
};

export const REQUEST_LABELS: Record<RequestType, RequestLabels> = {
  profile_refresh: {
    modalTitle: "Refresh request",
    bannerTitle: "Refresh request sent already",
    bannerDescriptionSingle: (sentencePart: string) =>
      `Refresh request was already sent ${sentencePart}. Please confirm if you want to send another one.`,
    bannerDescriptionMultiple:
      "Refresh request was already sent. Please confirm if you want to send another one.",
    instructionText:
      "An email will be sent prompting the investor to refresh this compliance profile.",
    successMessage: "Refresh request sent successfully",
    resendSuccessMessage: "Refresh request resent successfully",
    errorMessage: "Unable to send refresh request. Please try again or contact support.",
    resendErrorMessage:
      "Unable to resend refresh request. Please try again or contact support.",
  },
  document_refresh: {
    modalTitle: "Document update request",
    bannerTitle: "Document update request sent already",
    bannerDescriptionSingle: (sentencePart: string) =>
      `Document update request was already sent ${sentencePart}. Please confirm if you want to send another one.`,
    bannerDescriptionMultiple:
      "Document update request was already sent. Please confirm if you want to send another one.",
    instructionText:
      "An email will be sent prompting the investor to update the expired document(s) in this compliance profile.",
    successMessage: "Document update request sent successfully",
    resendSuccessMessage: "Document update request resent successfully",
    errorMessage:
      "Unable to send document update request. Please try again or contact support.",
    resendErrorMessage:
      "Unable to resend document update request. Please try again or contact support.",
  },
};

export const REQUEST_TYPE_TO_CASE_TYPE: Record<RequestType, ComplianceCaseTypeEnum> = {
  profile_refresh: ComplianceCaseTypeEnum.ProfileRefresh,
  document_refresh: ComplianceCaseTypeEnum.DocumentRefresh,
};
